import { render, staticRenderFns } from "./GBWeekFirstDay.vue?vue&type=template&id=6b5ffc00&"
import script from "./GBWeekFirstDay.vue?vue&type=script&lang=js&"
export * from "./GBWeekFirstDay.vue?vue&type=script&lang=js&"
import style0 from "./GBWeekFirstDay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports